import React from 'react';
import { Menu, Checkbox } from 'semantic-ui-react';

export const MenuItem = ({
  filter,
  selectedFilters,
  changeFilter,
  name,
  title,
}) => {
  let isSelected = false;
  if (filter.value === 'All') {
    isSelected = filter.areAllSelected;
  } else {
    isSelected =
      selectedFilters &&
      selectedFilters.values &&
      selectedFilters.values.indexOf(filter.value) !== -1;
  }
  return (
    <Menu.Item>
      <Checkbox
        label={filter.text}
        checked={isSelected}
        onChange={() =>
          isSelected
            ? changeFilter({
                name,
                title,
                value: filter.value,
                selected: false,
              })
            : changeFilter({ name, title, value: filter.value, selected: true })
        }
      />
    </Menu.Item>
  );
};

export default MenuItem;
